<template>
<div class="main merchant-settings">

	<div class="list-view">

		<h1>Merchant Settings</h1>

		<div class="sub-header">
		</div>

		<div v-if="showFilters" class="filters">
			<div class="title">Select which merchant settings you want to edit...</div>
			<div :class="['filter-list-button-large', settingSet == 'CREDIT_CARD'? 'active' : '']" @click="toggleSettings('CREDIT_CARD')">
				<div class="label">Credit Card</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'GIFT_CARD'? 'active' : '']" @click="toggleSettings('GIFT_CARD')">
				<div class="label">Gift Cards</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'TAX'? 'active' : '']" @click="toggleSettings('TAX')">
				<div class="label">Tax Rates</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'ITEM_FEES'? 'active' : '']" @click="toggleSettings('ITEM_FEES')">
				<div class="label">Other Taxes / Fees</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'GUN_BROKER'? 'active' : '']" @click="toggleSettings('GUN_BROKER')">
				<div class="label">GunBroker Connection</div>
			</div>
			<button v-if="settingSet == 'ITEM_FEES'" class="button action dashboard" @click="editItemFeeDefault({ item_fee_id: '', percent: '', department_id: '', category_id: '', product_id: '', transfers: '' })">Add Tax / Fee</button>
			<button v-else-if="settingSet != 'CREDIT_CARD'" class="button action dashboard" @click="saveSettings()">Save {{ settingTitles[settingSet] }}</button>
		</div>

		<div class="detail no-sidebar no-sub-header" v-if="!loading">

			<div v-if="settingSet == 'ITEM_FEES'" style="float: right;">
				<pagination :paging="paging" @updatePage="goToPage"></pagination>
			</div>

			<h3 style="margin: 0 0 1em 0;">{{ settingTitles[settingSet] }}</h3>

			<div v-if="settingSet == 'CREDIT_CARD'">

				<div class="two-columns">
					<div style="margin: 0 2em 0 0;">
						<div class="settings-group">
							<label>Payment Gateway</label>
							<select v-if="getAdministratorFlag" v-model="settings.payment_processor_id">
								<option value="">Select...</option>
								<option v-for="processor in settings.payment_processors" :value="processor.payment_processor_id" :key="'payment-processor-item-' + processor.payment_processor_id">{{ processor.description }}</option>
							</select>
							<h4 v-else style="margin-top: 0.25em;">{{ paymentProcessorName }}</h4>
						</div>
						<div v-if="showGatewayRow('gateway_merchant_id')" class="settings-group">
							<label>{{ gatewayLabel('gateway_merchant_id') }}</label>
							<input v-if="getAdministratorFlag" type="text" v-model="settings.gateway_merchant_id" :readonly="!getAdministratorFlag" />
						</div>
						<div v-if="showGatewayRow('gateway_merchant_id')" class="instruction"></div>

						<div v-if="showGatewayRow('gateway_password')" class="settings-group">
							<label>{{ gatewayLabel('gateway_password') }}</label>
							<input type="text" style="-webkit-text-security: disc; text-security: disc;" v-model="settings.gateway_password" :readonly="!getAdministratorFlag">
						</div>
						<div v-if="showGatewayRow('gateway_password')" class="instruction"></div>

						<div v-if="showGatewayRow('gateway_id')"  class="settings-group">
							<label>{{ gatewayLabel('gateway_id') }}</label>
							<input type="text" v-model="settings.gateway_id" :readonly="!getAdministratorFlag">
						</div>
						<div v-if="showGatewayRow('gateway_id')" class="instruction"></div>

						<div v-if="showGatewayRow('gateway_key')" class="settings-group">
							<label>{{ gatewayLabel('gateway_key') }}</label>
							<input type="text" style="-webkit-text-security: disc; text-security: disc;" v-model="settings.gateway_key" :readonly="!getAdministratorFlag">
						</div>
						<div v-if="showGatewayRow('gateway_key')" class="instruction"></div>

						<div v-if="showGatewayRow('gateway_card_present_identifier')" class="settings-group">
							<label>{{ gatewayLabel('gateway_card_present_identifier') }}</label>
							<input type="text" v-model="settings.gateway_card_present_identifier" :readonly="!getAdministratorFlag">
						</div>
						<div v-if="showGatewayRow('gateway_card_present_identifier')" class="instruction"></div>

						<div v-if="showGatewayRow('gateway_authorization_string')" class="settings-group">
							<label>{{ gatewayLabel('gateway_authorization_string') }}</label>
							<input v-if="getAdministratorFlag" type="text" v-model="settings.gateway_authorization_string">
							<h4 v-else style="margin-top: 0.25em;">{{ settings.gateway_authorization_string }}</h4>
						</div>
						<div v-if="showGatewayRow('gateway_authorization_string')" class="instruction"></div>

						<label>Accept American Express</label>
						<div v-if="getAdministratorFlag" style="margin: 0 0 1em 0;">
							<binary-toggle v-model="settings.accept_amex" labels="Yes,No" values="1," :key="'accept_amex_' + settings.accept_amex" />
						</div>
						<div v-else>
							<h4 style="margin-top: 0.25em;">{{ settings.accept_amex ? 'Yes' : 'No' }}</h4>
						</div>
						<p style="color: red;"><b>Enabling or disabling AmEx at your credit card terminal and through CDS is a multi-step process.</b></p>
						<p style="color: red;"><b>First, </b>contact {{ paymentProcessorName }} to have them enable / disable AmEx at your credit card terminals.</p>
						<p style="color: red;"><b>After </b>{{ paymentProcessorName }} has completed that change, you can use the button below to notify CDS to update your settings.</p>
						<div class="v-spaced">
							<button class="button action dashboard" @click="requestSettingsChange('Credit card settings change...')">Request Settings Change</button>
						</div>
					</div>
					<div>

						<div v-if="settings.zero_fee_enabled" style="margin: 0 2em 0 0;">
							<h3>Zero Fee Program Enabled</h3>
							<p>You are currently enrolled in the Zero Fee program<br>with {{ paymentProcessorName }}.</p>
							<p>With this program you are not charged transaction processing fees. Your merchant account collects a "Card Service Fee" directly from your customer at the time of sale. </p>

							<label>Amount charged to customers</label>
							<number-input :decimals='3' v-model="settings.zero_fee_enabled" :key="'zero_fee_enabled_' + settings.zero_fee_enabled" disabled />
							<span class="note">Shown as decimal, e.g. 0.040 = 4%</span>
							<div class="v-spaced">
								<button class="button action dashboard" @click="requestSettingsChange('Zero Fee program change...')">Request Zero Fee Change</button>
							</div>

							<div style="margin: 2em 0 0 0;">
								<router-link to="/reports/payment-fees-external">Zero Fee Report...</router-link>
							</div>

						</div>

						<div v-else>
							<div v-if="paymentProcessorCode == 'TNBC' || paymentProcessorCode == 'FASTCHARGE'" style="margin: 0 1em 2em 0; padding: 0 0 2em 0; border-bottom: 1px solid #ccc;">
								<p>Did you know that {{ paymentProcessorName }} offers a Zero Fee program?</p>
								<p>Zero Fee allows the processor to collect a "Card Service Fee" directly from the customer at the time of sale. This means no transaction fees are charged to you, and only funds for your actual sales are settled to your bank.</p>
								<p>Contact us for more information.</p>
								<button class="button action dashboard" @click="requestSettingsChange('Zero Fee program info...')">Request Zero Fee Info</button>
							</div>
							<p><b>NOTE:</b> Card processing fees are not allowed in some states.  Check your state or local laws to confirm your eligibility and the maximum percentage allowed.</p>

							<div v-if="getClientTypeCode == 'CDS'">
								<p>Add a fee when customers use a credit card at <b>POS</b>?</p>
								<label>Enter the fee percent.</label>
								<number-input :decimals='3' v-model="settings.pos_credit_card_fee" :key="'pos_credit_card_fee' + settings.pos_credit_card_fee" />
								<span class="note">Enter as decimal, e.g. 0.035 = 3.5%</span>
								<div class="v-spaced">
									<label class="checkbox with-outside-label">
										<input type="checkbox" v-model="settings.pos_credit_card_fee_taxable">
										<span><i class="fas fa-check-circle"></i></span>
										<span class="label-text">Credit card fees are taxable at <b>POS</b></span>
									</label>
								</div>
							</div>

							<p>Add a fee when customers use a credit card at <b>Checkout</b>?</p>
							<label>Enter the fee percent.</label>
							<number-input :decimals='3' v-model="settings.credit_card_fee" :key="'credit_card_fee_' + settings.credit_card_fee" />
							<span class="note">Enter as decimal, e.g. 0.035 = 3.5%</span>
							<div class="v-spaced">
								<label class="checkbox with-outside-label">
									<input type="checkbox" v-model="settings.credit_card_fee_taxable">
									<span><i class="fas fa-check-circle"></i></span>
									<span class="label-text">Credit card fees are taxable at <b>Checkout</b></span>
								</label>
							</div>
							<button class="button action dashboard" @click="saveSettings()">Save Credit Card Fee</button>
						</div>

					</div>
				</div>

			</div>

			<div v-if="settingSet == 'GIFT_CARD'">

				<div class="settings-group">
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.disable_gift_cards">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Disable gift cards at <b>Checkout</b></span>
					</label>
				</div>
				<div class="settings-group">
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.pos_disable_gift_cards">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Disable gift cards at <b>POS</b></span>
					</label>
				</div>
				<div class="note v-space">When checked, gift cards payments will not be accepted at POS or Checkout.</div>
			</div>

			<div v-if="settingSet == 'TAX'">
				<div class="settings-group">
					<label>Your Store's Sales Tax Rate</label>
					<number-input :decimals='5' v-model="settings.tax_rate" :key="'tax_rate_' + settings.tax_rate" />
					<div class="note">Enter as decimal, e.g. 0.065 = 6.5%</div>
				</div>
				<div class="two-columns settings-columns" style="margin: 2em 0 0 0;">
					<div class="settings-group">
						<label class="full">Which shipped web sales are charged sales tax?</label>
						<label class="radio first">
							<input :disabled="noAdvancedSettings" type="radio" v-model="settings.tax_orders" value="in-state">
							<span :class="{ disabled: noAdvancedSettings }"><i class="fas fa-check-circle"></i>In-state web sales only</span>
						</label>
						<label class="radio last">
							<input :disabled="noAdvancedSettings" type="radio" v-model="settings.tax_orders" value="all">
							<span :class="{ disabled: noAdvancedSettings }"><i class="fas fa-check-circle"></i>All web sales (in-state and out-of-state)</span>
						</label>
					</div>
					<div class="instruction">
						All <b>in-store pickup</b> web orders will be charged sales tax using your store's sales tax rate.<br />
						You can set which <b>shipped</b> web orders should also be charged sales tax.
					</div>
				</div>
				<div class="two-columns settings-columns">
					<div class="settings-group">
						<label class="full">What is the sales tax basis for shipped web sales?</label>
						<label class="radio first">
							<input :disabled="noAdvancedSettings" type="radio" v-model="settings.tax_basis" value="store">
							<span :class="{ disabled: noAdvancedSettings }"><i class="fas fa-check-circle"></i>Your location's sales tax rate</span>
						</label>
						<label class="radio last">
							<input :disabled="noAdvancedSettings" type="radio" v-model="settings.tax_basis" value="customer">
							<span :class="{ disabled: noAdvancedSettings }"><i class="fas fa-check-circle"></i>Your customer's shipping address</span>
						</label>
						<p v-if="noAdvancedSettings">
							<i class="fas fa-ban"></i> These settings are only available when using one of our new website templates.
						</p>
					</div>
					<div class="instruction">
						You can set the tax basis for <b>shipped</b> web orders to use either your store's tax rate or the tax authority of your customer's shipping address.
					</div>
				</div>
			</div>

			<div v-if="settingSet == 'ITEM_FEES'">
				<div class="settings-group ">
					<div class="item-fee-defaults-list">
						<label>Type</label>
						<label>Rate</label>
						<label>Applies To</label>
						<label></label>
					</div>
					<div v-for="itemFeeDefault in settings.item_fee_defaults" class="item-fee-defaults-list item-fee clickable-list-item">
						<div @click="editItemFeeDefault(itemFeeDefault)">{{ itemFeeDefault.description }}</div>
						<div @click="editItemFeeDefault(itemFeeDefault)">{{ itemFeeDefault.percent }}</div>
						<div @click="editItemFeeDefault(itemFeeDefault)">{{ itemFeeDefault.applies_to_code }} &rang; {{ itemFeeDefault.applies_to_name }}</div>
						<div class="center" @click="confirmDeleteItemFeeDefault(itemFeeDefault)"><i class="fa fa-trash-alt"></i></div>
					</div>
				</div>
			</div>

			<div v-if="settingSet == 'GUN_BROKER'" class="two-columns settings-columns" style="align-items: start;">
				<div class="settings-group">
					<p>Save your GunBroker login info here to enable listing from FlightDeck.</p>
					<label class="full">GunBroker Username</label>
					<input type="text" v-model="settings.gunbroker_username" style="width: 20em;">
					<label class="full">GunBroker Password</label>
					<input type="text" style="-webkit-text-security: disc; text-security: disc; width: 20em;" v-model="settings.gunbroker_password">
				</div>
				<div class="instruction"></div>
				<div class="settings-group">
					<p><b>IMPORTANT:</b> You need to save webhook settings directly in GunBroker so that items sold will generate orders in Flight Deck!</p>
					<p>Log in to your GunBroker account and navigate to Toolbox > Webhooks where you will see this screen...</p>
				</div>
				<div class="instruction"></div>
				<div class="settings-group ">
					<img src="https://cdsvault.com/marketing/gunbrokerwebhooks.png" style="width: 400px;">
				</div>
				<div class="instruction">
					<p><b>Provide your Webhook URL and Credentials</b></p>
					<div class="indent">
						<p>Base URL to call your Webhooks<br>
						<code>https://your-domain-name</code></p>
						<p>Username<br>
						<code>your_cds_username</code></p>
						<p>Password<br>
						<code>your_cds_password</code></p>
					</div>
					<p><b>Configure Webhook Settings</b></p>
					<div class="indent">
						<p>Webhooks: Items Sold<br>
						<code>enable</code></p>
						<p>Endpoint<br>
						<code>/api/gun_broker.php</code></p>
					</div>
				</div>
			</div>

		</div>

        <loading v-else></loading>
	</div>

	<div v-if="showEditItemFeeDefault" class="modal">
		<div class="inner" style="max-height: 40em;">
			<h2>Other Taxes / Fees</h2>
			<div class="content" style="max-height: 40em;">
				<label>Type</label>
				<div class="input-with-control">
					<select v-model="editingItemFeeDefault.item_fee_id">
						<option value="">Select...</option>
						<option v-for="(itemFee, index) in settings.item_fees" :value="itemFee.item_fee_id">{{ itemFee.description }}</option>
					</select>
					<div class="button action input-go" @click="showItemTypes = true"><i class="fas fa-edit"></i></div>
				</div>
				<label>Rate</label>
				<div class="one-three-columns align-center">
					<number-input :decimals='5' v-model="editingItemFeeDefault.percent" :key="'item_fee_rate_' + editingItemFeeDefault.percent" />
					<span class="note left v-spaced">Enter as decimal, e.g. 0.065 = 6.5%</span>
				</div>
				<checkbox v-model="editingItemFeeDefault.applies_to_gross" label="Also applies to any charges / fees related to sale" :key="'applies_to_gross' + editingItemFee.applies_to_gross" class="v-spaced"/>
				<div class="note">Examples: CC Processing Fee, Background Check Fee</div>
				<div class="divider"></div>

				<div class="apply-to-section">
					<h3>Apply this tax/fee to...</h3>
					<div class="radio-set">
						<input type="radio" id="department" name="applies-to" value="department" v-model="appliesToSelected">
						<label for="department"><strong>Department and/or Category</strong></label>
						<div class="applies-to-options" :class="{ 'option-selected': appliesToSelected === 'department' }">
							<label>Applies to this Department</label>
							<select v-model="editingItemFeeDefault.department_id" @change="getCategories(editingItemFeeDefault.department_id)">
								<option value="">Select...</option>
								<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
							</select>
							<label>Applies to this Category</label>
							<select v-model="editingItemFeeDefault.category_id">
								<option value="">Select...</option>
								<option v-for="(category, index) in categories" :value="category.category_id">{{ category.description }}</option>
							</select>
						</div>

						<input type="radio" id="product" name="applies-to" value="product" v-model="appliesToSelected">
						<label for="product"><strong>Specific Product</strong></label>
						<div class="applies-to-options" :class="{ 'option-selected': appliesToSelected === 'product' }">
							<label>Applies to this Product</label>
							<div class="input-with-control">
								<input type="text" :value="editingItemFeeDefault.product_id ? editingItemFeeDefault.applies_to_name : ''" placeholder="Search products..." readonly @click="searchProducts = true">
								<div class="button action input-go" @click="searchProducts = true"><i class="fas fa-search"></i></div>
							</div>
						</div>

						<input type="radio" id="transfers" name="applies-to" value="true" :checked="editingItemFeeDefault.transfers" @change="handleTransfersSelected">
						<label for="transfers"><strong>All Transfer Products</strong></label>
					</div>
				</div>

				<div v-if="modalMessage" class="note v-spaced">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showEditItemFeeDefault = false, appliesToSelected = ''">Cancel</div>
				<div :class="['button', 'spaced', canSaveItemFeeDefault ? 'action' : 'disabled']" @click="saveItemFeeDefault()">Save</div>
			</div>
		</div>
	</div>

	<div v-if="showConfirmDelete" class="modal">
		<div class="inner">
			<h2>Delete Other Tax / Fee</h2>
			<div class="content">
				<p>{{ editingItemFeeDefault.applies_to_code }} &rang; {{ editingItemFeeDefault.applies_to_name }}</p>
				<p>Are you sure you want to delete this tax / fee?</p>
				<div v-if="modalMessage" class="note v-spaced">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showConfirmDelete = false">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'neutral', 'spaced']" @click="deleteItemFeeDefault()">Yes, Delete Tax / Fee</div>
			</div>
		</div>
	</div>

	<div v-if="showItemTypes" class="modal">
		<div class="inner">
			<h2>Tax / Fee Types</h2>
			<div class="content">
				<label>Description</label>
				<div v-for="itemFee in settings.item_fees" class="item-fee clickable-list-item" @click="editItemFee(itemFee)">
					<div>{{ itemFee.description }}</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showItemTypes = false">Cancel</div>
				<div class="button neutral spaced" @click="editItemFee({ client_id: getClientId, description: '' })">Add Tax / Fee Type</div>
			</div>
		</div>
	</div>

	<div v-if="showEditItem" class="modal">
		<div class="inner">
			<h2>Tax / Fee Types</h2>
			<div class="content">
				<label>Description</label>
				<input type="text" v-model="editingItemFee.description" :disabled="!editingItemFee.client_id">
				<div v-if="editingItemFee.client_id">
					<checkbox v-model="editingItemFee.inactive" label="Deactivate this type" :key="'inactive' + editingItemFee.inactive" class="v-spaced"/>
				</div>
				<div v-else class="note">
					<i class="fa fa-ban"></i> This tax / fee type belongs to the system.
				</div>
				<div v-if="modalMessage" class="note v-spaced">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showEditItem = false">Cancel</div>
				<div :class="['button', 'spaced', !saving && editingItemFee.client_id && editingItemFee.description ? 'action' : 'disabled']" @click="saveItemFee()">Save</div>
			</div>
		</div>
	</div>

	<product-search v-if="searchProducts" @assignProduct="assignProduct" @cancel="searchProducts = false" />

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
import ProductSearch from '@/components/ProductSearch.vue'
import NumberInput from '@/components/NumberInput.vue'
import BinaryToggle from '@/components/BinaryToggle'
import Checkbox from '@/components/Checkbox.vue'

export default {
	name: 'merchant-settings',
	props: ['setting'],
    components: {
		'product-search': ProductSearch,
		'number-input': NumberInput,
		'binary-toggle': BinaryToggle,
		'checkbox': Checkbox
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			settingTitles: {
				'CREDIT_CARD': 'Credit Card',
				'GIFT_CARD': 'Gift Cards',
				'TAX': 'Tax Rates',
				'ITEM_FEES': 'Other Taxes / Fees',
				'GUN_BROKER': 'GunBroker'
			},
			settingSet: '',
			settings: {},
			paging: {},
			page: 1,
			paymentProcessors: [],
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			clientId: '',
			departments: [],
			newDepartment: '',
			categories: [],
			newCategory: '',
			currentFilterList: [],
			editingItemFeeDefault: {},
			showEditItemFeeDefault: false,
			editingItemFee: {},
			showItemTypes: false,
			showEditItem: false,
			modalMessage: '',
			searchProducts: false,
			showConfirmDelete: false,
			noAdvancedSettings: false,
			appliesToSelected: ''
		}
	},
	created() {
		this.fetchRouteLastRequested()
		this.settingSet = this.setting ? this.setting.toUpperCase() : 'CREDIT_CARD'
		this.getSettings()
	},
	watch: {
		appliesToSelected(val) {
			if (val !== 'transfers') {
				this.editingItemFeeDefault.transfers = false;
			}
			if (val === 'product') {
				if (!this.editingItemFeeDefault.hasOwnProperty('product_id')) {
					this.$set(this.editingItemFeeDefault, 'product_id', null);
				}
				if (!this.editingItemFeeDefault.hasOwnProperty('applies_to_name')) {
					this.$set(this.editingItemFeeDefault, 'applies_to_name', '');
				}
			}
		}
	},
	computed: {
		paymentProcessorCode() {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return '' }
			return this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['payment_processor_code']
		},
		paymentProcessorName() {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return '' }
			return this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['description']
		},
		canSaveItemFeeDefault() {
			const fee = this.editingItemFeeDefault;
			return fee.item_fee_id &&
					fee.percent &&
					(
						(this.appliesToSelected === 'department' && fee.department_id) ||
						(this.appliesToSelected === 'product' && fee.product_id) ||
						(this.appliesToSelected === 'transfers')
					);
			}
	},
	methods: {
		getSettings() {
			if (this.loading) { return }
            this.loading = true
			this.settings = {}
			this.message = ''
			this.apiCall({ destination: 'get_item_settings', data: { section: this.settingSet, page: this.page } }).then(obj => {
                this.loading = false
				this.settings = obj.settings
				// set string "0" as numeric zero and set to falsey when/if applied to toggle inputs
				for (let key in this.settings) {
  					if (obj[key] === "0") {
    					obj[key] = 0;
  					}
				}
				if (obj.paging) {
					this.paging = obj.paging
				}
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		toggleSettings(which) {
			if (which != this.settingSet) {
				this.settingSet = which
				if (this.settingSet == 'ITEM_FEES' && this.departments.length == 0) {
					this.getDepartments()
				}
				this.page = 1
				this.getSettings()
			}
		},
		goToPage(page) {
			this.page = page
			this.getSettings()
		},
		showGatewayRow(which) {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return }
			var processorCode = this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['payment_processor_code']
			switch (which) {
				case 'gateway_id':
					return ['TNBC','VM','EPROC','AUTH','SKIP','PAYEEZY','NETMERCH','PAYMENTXP'].indexOf(processorCode) > -1
				case 'gateway_key':
					return ['TNBC','VM','EPROC','AUTH','SKIP','PAYEEZY','NETMERCH','PAYMENTXP'].indexOf(processorCode) > -1
				case 'gateway_merchant_id':
					return ['VM','PAYEEZY'].indexOf(processorCode) > -1
				case 'gateway_password':
					return ['PAYEEZY'].indexOf(processorCode) > -1
				case 'gateway_card_present_identifier':
					//return ['TNBC'].indexOf(processorCode) > -1
					return false
				case 'gateway_authorization_string':
					return ['TNBC','FASTCHARGE'].indexOf(processorCode) > -1
			}
		},
		gatewayLabel(which) {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return }
			var processorCode = this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['payment_processor_code']
			switch (which) {
				case 'gateway_id':
					switch (processorCode) {
						case 'TNBC':
							return 'Username'
						case 'VM':
							return 'User ID'
						case 'EPROC':
							return 'ePN Account'
						case 'AUTH':
							return 'Gateway ID'
						case 'SKIP':
							return 'Serial Number'
						case 'PAYEEZY':
							return 'HMAC Key ID'
						case 'NETMERCH':
							return 'Username'
						case 'PAYMENTXP':
							return 'Merchant ID'
						case 'FASTCHARGE':
							return 'Account ID'
					}
				case 'gateway_key':
					switch (processorCode) {
						case 'TNBC':
							return 'Password'
						case 'VM':
							return 'PIN'
						case 'EPROC':
							return 'Restrict Key'
						case 'AUTH':
							return 'Transaction Key'
						case 'SKIP':
							return 'Developer Serial Number'
						case 'PAYEEZY':
							return 'HMAC Key'
						case 'NETMERCH':
							return 'Password'
						case 'PAYMENTXP':
							return 'Merchant Key'
						case 'FASTCHARGE':
							return 'Merchant PIN'
					}
				case 'gateway_merchant_id':
					switch (processorCode) {
						case 'TNBC':
							return 'Username'
						case 'PAYEEZY':
							return 'Gateway ID'
					}
				case 'gateway_merchant_id':
					switch (processorCode) {
						case 'VM':
							return 'Merchant ID'
					}

				case 'gateway_password':
					switch (processorCode) {
						case 'TNBC':
							return 'API Key'
						case 'PAYEEZY':
							return 'Gateway Password'
					}

				case 'gateway_card_present_identifier':
					switch (processorCode) {
						case 'TNBC':
							return 'Card Present Identifier'
					}

				case 'gateway_authorization_string':
					switch (processorCode) {
						case 'TNBC':
							return 'API Key'
						case 'FASTCHARGE':
							return 'API Key'
					}

			}
		},
		requestSettingsChange(which) {
			this.$router.push('/help-center/support-tickets-detail/new?topic=' + which)
		},
		getDepartments() {
			this.apiCall({ destination: 'get_list_departments' }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
		},
		getCategories(departmentId) {
			if (departmentId) {
				this.apiCall({ destination: 'get_list_categories', data: { department_id: departmentId } }).then(obj => {
					this.categories = obj.categories
				}).catch(err => {
					console.log(err)
				})
			} else {
				this.categories = []
			}
		},
		saveSettings() {
			if (this.saving) { return }
			this.message = 'Saving ' + this.settingSet.capitalizeWords() + ' settings...'
			this.messageTimeout = 0
			this.saving = true
			this.apiCall({ destination: 'save_item_settings', data: { section: this.settingSet, settings: this.settings } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (this.messageStatus == 'success') {
					this.message = this.settingSet.capitalizeWords() + ' settings saved.'
					this.messageTimeout = 2000
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		editItemFeeDefault(itemFeeDefault) {
			this.editingItemFeeDefault = itemFeeDefault
			if (this.editingItemFeeDefault.department_id) {
				this.getCategories(this.editingItemFeeDefault.department_id)
			}
			this.showEditItemFeeDefault = true
			this.initializeAppliesTo();
		},
		saveItemFeeDefault() {
			if (this.saving) { return }
			if (!this.canSaveItemFeeDefault) { return }
			if (this.appliesToSelected === 'department') {
				this.editingItemFeeDefault.transfers = false;
				this.editingItemFeeDefault.product_id = null;
			} else if (this.appliesToSelected === 'product') {
				this.editingItemFeeDefault.transfers = false;
				this.editingItemFeeDefault.department_id = null;
				this.editingItemFeeDefault.category_id = null;
			} else if (this.appliesToSelected === 'transfers') {
				this.editingItemFeeDefault.transfers = true;
				this.editingItemFeeDefault.department_id = null;
				this.editingItemFeeDefault.category_id = null;
				this.editingItemFeeDefault.product_id = null;
			}
			this.saving = true
			this.modalMessage = 'Saving...'
			this.apiCall({ destination: 'save_item_fee_default', data: this.editingItemFeeDefault }).then(obj => {
				this.saving = false
				this.modalMessage = obj.message
				if (obj.status == 'success') {
					this.showEditItemFeeDefault = false
					this.categories = []
					this.getSettings()
					this.appliesToSelected = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		editItemFee(itemFee) {
			this.editingItemFee = itemFee
			this.showEditItem = true
		},
		saveItemFee() {
			if (this.saving) { return }
			if (!this.editingItemFee.description || !this.editingItemFee.client_id) { return }
			this.saving = true
			this.modalMessage = 'Saving...'
			this.apiCall({ destination: 'save_item_fee', data: this.editingItemFee }).then(obj => {
				this.saving = false
				this.modalMessage = obj.message
				if (obj.status == 'success') {
					this.showEditItem = false
					this.getSettings()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		assignProduct(product) {
			this.searchProducts = false
			this.editingItemFeeDefault.applies_to_name = product.description + ' (ID: ' + product.product_id + ')'
			this.editingItemFeeDefault.product_id = product.product_id
		},
		confirmDeleteItemFeeDefault(itemFeeDefault) {
			this.editingItemFeeDefault = itemFeeDefault
			this.showConfirmDelete = true
		},
		deleteItemFeeDefault() {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Deleting...'
			this.editingItemFeeDefault.delete = 1
			this.apiCall({ destination: 'save_item_fee_default', data: this.editingItemFeeDefault }).then(obj => {
				this.saving = false
				this.modalMessage = obj.message
				if (obj.status == 'success') {
					this.showConfirmDelete = false
					this.editingItemFeeDefault = {}
					this.getSettings()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		handleTransfersSelected() {
			this.editingItemFeeDefault.transfers = true;
			this.appliesToSelected = 'transfers';
		},
		initializeAppliesTo() {
			if (this.editingItemFeeDefault.transfers) {
			this.appliesToSelected = 'transfers';
			} else if (this.editingItemFeeDefault.department_id) {
			this.appliesToSelected = 'department';
			} else if (this.editingItemFeeDefault.product_id) {
			this.appliesToSelected = 'product';
			} else {
			this.appliesToSelected = '';
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.item-fee-defaults-list {
	display: grid;
	grid-template-columns: 1fr 4em 2fr 2em;
	align-items: center;
}

.item-fee {
	padding: 0.5em 0;
	border-top: 1px dotted #ccc;
}

.modal {
	.inner {
		max-height: 47em !important;
	}
}

.applies-to-options {
	width: 90%;
	margin-left: 1.5em;
	margin-top: 0.5em;
	filter: opacity(0.5);
	pointer-events: none;
}
.option-selected {
	filter: opacity(1);
	pointer-events: all;
}
</style>
